import React, { useEffect, useState  } from 'react'
import { useQuery } from 'react-query'
import { getResourceList } from '../models/GraphQLModel'
import SEO from './../utils/SEOMetaTags'
import { BasicGridModule, Loading, GeneralErrorBoundary, ErrorHandler } from '@scrippsproduct/scripps-external-component-library'
import { GetAirdateWrapper } from "@scrippsproduct/scripps-external-component-library"

import './../scss/Shows.scss'

const NETWORK = process.env.REACT_APP_NETWORK
const SCHEDULE_ENDPOINT = process.env.REACT_APP_SCHEDULE_V2

export default function Shows() {
    const {isError, isSuccess, isLoading, data} = useQuery(['showsPage', {resourceName: 'showspage'}], getResourceList)
    const [showData, setShowData] = useState([])

    useEffect(() => {
        
        if (isSuccess && data) {
            const clonedData = structuredClone(data)
            for (let i=0; i < clonedData.length; i++) {
                clonedData[i].content = <GetAirdateWrapper 
                programId={clonedData[i].seriesPrefix} 
                separatorType='pipe'
                NETWORK={NETWORK}
                SCHEDULE_ENDPOINT={SCHEDULE_ENDPOINT} />
            }
            
            setShowData([...clonedData])
        }
    }, [data, isSuccess])
    

    return (<>
        <SEO
            title="Shows | Laff"
        />
        <content-constrainer class="content-constrainer--no-padding content-constrainer--no-border">
            <h2 className="page-content-header">Our Programming</h2>
        </content-constrainer>
        <div style={{
            backgroundImage: `linear-gradient(to bottom, transparent 0%, transparent 10rem, #fff 10rem, #fff 100%)`,
            minHeight: '70vh',
        }}>
            { (isSuccess && showData.length > 0) && 
                <GeneralErrorBoundary 
                    errorTitle="Sorry, we're having trouble loading our programming list." 
                    errorMessage="Please try again later. If the problem persists please contact us at <a href='https://support.iontelevision.com/support/home'>our support page</a>."
                > 
                    <content-constrainer class="content-constrainer--no-padding content-constrainer--no-border">
                        <BasicGridModule 
                            items={showData}
                            itemsPerRow={4}
                            gap={`2rem 2.5rem`}
                            title={''}
                            itemComponent={{
                                layout: `ImageCard`,
                                props: {
                                    fullCardClickable: true,
                                }
                            }}
                            handleClicks={eventDetails => {
                                console.table(eventDetails.resourceId, eventDetails.type)
                            }}
                            classname="programs-list"
                        />
                    </content-constrainer>
                </GeneralErrorBoundary>
            }
            { (isError) && 
                <ErrorHandler
                    title="Sorry, we're having trouble loading our programming list."
                    message="Please try again later. If the problem persists please contact us at <a href='https://support.iontelevision.com/support/home'>our support page</a>."
                />
            }
            {(isLoading) && <Loading spinnerColor="hsl(0deg 0% 86.68% / 77%)" topOffset="28%" />}
        </div>    
        
    </>)
}
